import React from 'react';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Shuttle, ShuttleWithoutPassengersInfo } from '../../domain/shuttle';

import EditIcon from '../Icons/EditIcon';
import DeleteIcon from '../Icons/DeleteIcon';

const formatDate = (date: string) => new Date(date).toDateString();

interface Props {
  shuttle: Shuttle | ShuttleWithoutPassengersInfo;
  onRemove: () => void;
}

export const ShuttleShoppingCartSummary = ({ shuttle, onRemove, onEdit }: Props) => {
  const { t } = useTranslation();

  return (
    <Box py={2} width="100%" borderBottom="1px solid rgba(0, 0, 0, 0.12)">
      <Stack flexDirection="row" alignItems="center" justifyContent="space-between">
        <Typography color="#333334" fontWeight={700}>
          {t('shuttle_summary.title')}
        </Typography>
        {shuttle.DiscountCaption ? (
          <Typography
            color="#EF60A3"
            fontFamily="Gotham-Medium"
            backgroundColor="rgba(239, 96, 163, 0.1)"
            fontSize="14px"
            border="1px solid #EF60A3"
            borderRadius="12px"
            padding="0.5em"
          >
            {shuttle.DiscountCaption}
          </Typography>
        ) : null}
        <Stack direction="row">
          {false && (
            <IconButton onClick={onEdit}>
              <EditIcon fontSize="small" />
            </IconButton>
          )}
          <IconButton onClick={onRemove}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Stack>
      </Stack>

      <Stack width="100%" mt={1} flexDirection="row" gap={2}>
        <Stack width="100%">
          <Typography fontWeight={400}>
            {shuttle.originText} - {shuttle.destinationText}
          </Typography>

          <Typography fontSize={12} fontWeight={400}>
            {formatDate(shuttle.departureDate)} - {formatDate(shuttle.arrivalDateTime)}
          </Typography>

          <Stack flexDirection="row" justifyContent="space-between" gap={2} mt={1}>
            <Typography fontSize={12} fontWeight={400}>
              {shuttle.passengersQ} {shuttle.passengersQ > 1 ? t('shuttle_shopping_cart_summary.passengers') : t('shuttle_shopping_cart_summary.passenger')}
            </Typography>
            <Stack>
              <Typography fontSize={12} fontWeight={500} fontFamily="Gotham-Book" variant={shuttle.DiscountAmount ? 'line-through' : 'none'}>
                ${shuttle.total.toFixed(2)} USD
              </Typography>
              {shuttle.DiscountAmount ? (
                <Typography mt={0.5} fontSize={12} fontWeight={500}>
                  ${shuttle.DiscountAmount.toFixed(2)} USD
                </Typography>
              ) : null}
            </Stack>
          </Stack>
        </Stack>

        <Stack></Stack>
      </Stack>
    </Box>
  );
};
